import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Check from '@material-ui/icons/Check';
import Checkbox from '@material-ui/core/Checkbox';
import FormLabel from '@material-ui/core/FormLabel';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { Divider } from '@material-ui/core';
import makeStyles from '@material-ui/styles/makeStyles';
import { grayColor } from 'assets/jss/material-dashboard-pro-react';
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import DataGrid from 'components/DataGrid/DataGrid';
import GridItem from 'components/Grid/GridItem';
import GridContainer from 'components/Grid/GridContainer';

import commentsColumnConfig from './commentsColumnConfig';

const useStyles = makeStyles({
  sectionBody: {
    padding: '16px 20px',
    '& label': {
      color: grayColor[1],
    },
  },
  sectionTitle: {
    marginTop: 0,
    marginBottom: '16px',
  },
  sectionDivider: {
    marginBottom: '24px',
  },
  ratesRow: {
    '& > div': {
      marginTop: 0,
      marginBottom: '40px',
    },
  },
  commentsRow: {
    '& > div': {
      marginTop: 0,
      marginBottom: '16px',
    },
    '& > div:last-child': {
      marginBottom: 0,
    },
  },
});

const DishRatesAndComments = ({ dish, classes, getStarRate }) => {
  const { t } = useTranslation();
  const styles = useStyles();
  const [isShowOnlyComments, setIsShowOnlyComments] = useState(false);

  return (
    <Card>
      <CardBody className={styles.sectionBody}>
        <h3 className={styles.sectionTitle}>
          {t('mealForm.ratesAndCommentsCard')}
        </h3>
        <Divider className={styles.sectionDivider} />
        <GridContainer className={styles.ratesRow}>
          <GridItem md={12}>
            <FormLabel style={{ fontSize: '14px' }}>
              {t('form.field.avgRate')}
            </FormLabel>
            <h4>
              <b>{dish.rateAVG ? dish.rateAVG.toFixed(2) : '0'}</b>{' '}
              {t('form.field.basedOn')} {dish.rateCount || 0}{' '}
              {t('form.field.rates')}
            </h4>
            {getStarRate(dish.rateAVG)}
          </GridItem>
        </GridContainer>
        <GridContainer className={styles.commentsRow}>
          <GridItem md={12}>
            <FormLabel style={{ fontSize: '14px' }}>
              {t('common.heading.comments')}
            </FormLabel>
          </GridItem>
          <GridItem md={12}>
            <FormControlLabel
              control={
                <Checkbox
                  tabIndex={-1}
                  name="rates"
                  onClick={() => setIsShowOnlyComments(!isShowOnlyComments)}
                  checked={isShowOnlyComments}
                  checkedIcon={<Check className={classes.checkedIcon} />}
                  icon={<Check className={classes.uncheckedIcon} />}
                  classes={{
                    checked: classes.checked,
                    root: classes.checkRoot,
                  }}
                />
              }
              classes={{
                label: classes.label,
              }}
              label={t('common.heading.comments.checkboxDescription')}
            />
          </GridItem>
          <GridItem md={12}>
            {(dish?.brands ?? []).length > 0 && (
              <DataGrid
                key={isShowOnlyComments}
                disableTotal={true}
                filterable={false}
                sortable={false}
                paginationTop={true}
                paginationBottom={false}
                url={`/client-dish-rates-view?dish.id=${dish.id}`}
                columns={commentsColumnConfig}
                role="RATE"
                minRows={5}
                customDefaultPageSize={5}
                showPageSizeOptions={true}
                manipulateQuery={(requestData, query) => {
                  // eslint-disable-next-line no-underscore-dangle -- query param name required by the API
                  query._orX = [];
                  if (isShowOnlyComments) {
                    query['length_filter[gt][comment]'] = 1;
                  }
                  query.selectInBrands = dish.brands.map(brand => brand['@id']);

                  return query;
                }}
              />
            )}
          </GridItem>
        </GridContainer>
      </CardBody>
    </Card>
  );
};

export default DishRatesAndComments;
